<template>
  <div class="log-manage page-container">
    <el-card>
      <el-form :inline="true" :model="filterForm" class="demo-form-inline">
        <!-- 日期范围 -->
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onDateRangeChange">
          </el-date-picker>
        </el-form-item>

        <!-- 操作类型 -->
        <el-form-item label="操作类型">
          <el-select v-model="filterForm.operType" placeholder="请选择操作类型" clearable style="min-width:180px">
            <el-option v-for="type in businessTypes" :key="type.code" :label="type.desc" :value="type.code"></el-option>
          </el-select>
        </el-form-item>

        <!-- 查询用户 -->
        <el-form-item label="查询用户">
          <el-input v-model="filterForm.queryUser" placeholder="输入用户名" clearable></el-input>
        </el-form-item>

        <!-- 剔除用户 -->
        <el-form-item label="剔除用户">
          <el-input v-model="filterForm.excludeUser" placeholder="输入用户名" clearable></el-input>
        </el-form-item>

        <!-- 来源 -->
        <el-form-item label="来源">
          <el-select v-model="filterForm.source" placeholder="请选择来源" clearable>
            <el-option label="web" :value="1"></el-option>
            <el-option label="小程序" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="loadLogs">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="logs" v-loading="isLoading" style="width: 100%">
        <el-table-column prop="operTime" label="操作时间" width="160"></el-table-column>
        <el-table-column prop="source" label="来源" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.source === 1 ? 'web' : scope.row.source === 2 ? '小程序' : scope.row.source }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="系统模块"></el-table-column>
        <el-table-column prop="operType" label="操作类型" width="120">
            <template slot-scope="scope">
                <el-tag :type="getOperTypeTagType(scope.row.operType)">{{ getOperTypeLabel(scope.row.operType) }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="operName" label="操作人"></el-table-column>
        <el-table-column prop="operIp" label="操作IP"></el-table-column>
        <el-table-column prop="operLocation" label="操作地点"></el-table-column>
        <el-table-column prop="status" label="操作状态"></el-table-column>
        <el-table-column label="操作" width="230" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="viewLog(scope.row)">详情</el-button>
            <el-button v-if="isAdmin" size="mini" type="info" @click="queryNoteCount(scope.row)">查询</el-button>
            <el-button v-if="isAdmin" size="mini" type="danger" @click="deleteLog(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </el-card>

    <!-- 日志详情弹窗 -->
    <el-dialog title="日志详情" :visible.sync="showDialog" width="50%">
      <div v-if="currentLog">
        <el-descriptions column="2" border>
          <el-descriptions-item label="操作时间">{{ currentLog.operTime }}</el-descriptions-item>
          <el-descriptions-item label="来源">{{ currentLog.source === 1 ? 'web' : currentLog.source === 2 ? '小程序' : currentLog.source }}</el-descriptions-item>
          <el-descriptions-item label="系统模块">{{ currentLog.title }}</el-descriptions-item>
          <el-descriptions-item label="操作类型">
            <el-tag :type="getOperTypeTagType(currentLog.operType)">{{ getOperTypeLabel(currentLog.operType) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="操作人">{{ currentLog.operName }}</el-descriptions-item>
          <el-descriptions-item label="操作IP">{{ currentLog.operIp }}</el-descriptions-item>
          <el-descriptions-item label="操作地点">{{ currentLog.operLocation }}</el-descriptions-item>
          <el-descriptions-item label="操作状态">{{ currentLog.status }}</el-descriptions-item>
          <el-descriptions-item label="请求方法">{{ currentLog.method }}</el-descriptions-item>
          <el-descriptions-item label="请求URL" :span="2">{{ currentLog.operUrl }}</el-descriptions-item>
          <el-descriptions-item label="请求参数" :span="2">
            <pre style="margin:0;max-height:200px;overflow-y:auto;background:#f5f5f5;padding:8px;border-radius:2px;">{{ currentLog.operParam || '无' }}</pre>
          </el-descriptions-item>
          <el-descriptions-item label="返回结果" :span="2">
            <pre style="margin:0;max-height:200px;overflow-y:auto;background:#f5f5f5;padding:8px;border-radius:2px;">{{ currentLog.operResult || '无' }}</pre>
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ currentLog.remark || '无' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLogsList, getBusinessTypes } from '@/api/logs'
import axios from 'axios'

export default {
  name: 'LogManage',
  data() {
    return {
      filterForm: {
        operType: '',
        queryUser: '',
        excludeUser: '',
        source: '',
        dateStart: '',
        dateEnd: ''
      },
      dateRange: [],
      logs: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 5,
      pageSizes: [5, 10, 20, 50, 100],
      total: 0,
      showDialog: false,
      currentLog: null,
      businessTypes: [],
      operTypeMap: {
        insert: '新增',
        update: '修改',
        delete: '删除',
        export: '导出',
        import: '导入',
        force: '强退',
        genCode: '生成代码',
        clean: '清空数据',
        grant: '授权',
        login: '登录',
        logout: '退出',
        other: '其它'
      },
      operTypeTagTypeMap: {
        insert: 'success',
        update: 'primary',
        delete: 'danger',
        export: 'info',
        import: 'info',
        force: 'warning',
        genCode: 'info',
        clean: 'danger',
        grant: 'warning',
        login: 'success',
        logout: 'info',
        other: ''
      }
    }
  },
  created() {
    this.loadBusinessTypes()
    this.loadLogs()
  },
  computed: {
    isAdmin() {
      return localStorage.getItem('isAdmin') === 'true'
    }
  },
  methods: {
    async loadBusinessTypes() {
      try {
        const res = await getBusinessTypes()
        if (res && res.data && res.data.code === 200) {
          this.businessTypes = res.data.data || []
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取操作类型失败')
        }
      } catch (error) {
        // 检查是否是因为认证失败导致的错误（401/403）
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          // 认证相关的错误已经在 axios 拦截器中处理并跳转到登录页，无需额外提示
          console.log('Authentication failed, redirecting to login page')
          this.$message.error('长时间未操作，请重新登录')
        } else {
          this.$message.error('获取操作类型异常')
        }
      }
    },
    onDateRangeChange() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filterForm.dateStart = this.dateRange[0]
        this.filterForm.dateEnd = this.dateRange[1]
      } else {
        this.filterForm.dateStart = ''
        this.filterForm.dateEnd = ''
      }
    },

    async loadLogs() {
      this.isLoading = true
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          operType: this.filterForm.operType !== '' && this.filterForm.operType !== null ? this.filterForm.operType : undefined,
          source: this.filterForm.source !== '' && this.filterForm.source !== null ? this.filterForm.source : undefined,
          queryUser: this.filterForm.queryUser || undefined,
          excludeUser: this.filterForm.excludeUser || undefined,
          dateStart: this.filterForm.dateStart || undefined,
          dateEnd: this.filterForm.dateEnd || undefined
        }
        const res = await getLogsList(params)
        if (res && res.data && res.data.code === 200) {
          const data = res.data.data || {}
          this.logs = data.records || []
          this.total = data.total || 0
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取日志列表失败')
        }
      } catch (error) {
        // 检查是否是因为认证失败导致的错误（401/403）
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          // 认证相关的错误已经在 axios 拦截器中处理并跳转到登录页，无需额外提示
          console.log('Authentication failed, redirecting to login page')
          this.$message.error('长时间未操作，请重新登录')
        } else {
          this.$message.error('获取日志列表异常')
        }
      } finally {
        this.isLoading = false
      }
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadLogs()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.loadLogs()
    },

    resetFilters() {
      this.filterForm = {
        operType: '',
        queryUser: '',
        excludeUser: '',
        source: '',
        dateStart: '',
        dateEnd: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.loadLogs()
    },

    viewLog(row) {
      this.currentLog = row
      this.showDialog = true
    },

    deleteLog(row) {
      this.$confirm(`确定要删除这条日志记录吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await axios.post(`${process.env.VUE_APP_BASE_API}/logs/delete/${row.id}`)
          if (res && res.data && res.data.code === 200) {
            this.$message.success('删除成功')
            // 重新加载日志列表
            this.loadLogs()
          } else {
            this.$message.error((res && res.data && res.data.msg) || '删除失败')
          }
        } catch (error) {
          const status = error?.response?.status
          if (status === 401 || status === 403) {
            console.log('Authentication failed, redirecting to login page')
            this.$message.error('长时间未操作，请重新登录')
          } else {
            this.$message.error('删除日志异常')
          }
        }
      }).catch(() => {
        // 用户取消删除
      })
    },

    getOperTypeLabel(operType) {
      return this.operTypeMap[operType] || operType
    },

    getOperTypeTagType(operType) {
      return this.operTypeTagTypeMap[operType] || ''
    },

    async queryNoteCount(row) {
      const userId = row.userI
      if (userId === null || userId === undefined) {
        this.$message.warning('参数为null')
        return
      }
      try {
        const res = await axios.get(`${process.env.VUE_APP_BASE_API}/note/count/${userId}`)
        if (res && res.data && res.data.code === 200) {
          const count = res.data.data
          this.$message.success(`用户 ${row.operName || userId} 的记事数量：${count}`)
        } else {
          this.$message.error((res && res.data && res.data.msg) || '查询失败')
        }
      } catch (error) {
        this.$message.error('查询记事数量异常')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.log-manage {
  &.page-container {
    margin-top: -10px;
  }
  
  .el-card { margin-bottom: 12px }
  // .pagination { margin-top: 12px; display: flex; justify-content: flex-end }
  .el-form-item {
    margin-bottom: 12px;
  }
}

/* 表格表头样式 */
:deep(.el-table__header-wrapper th),
:deep(.el-table__fixed-header-wrapper th) {
  background-color: #f5f7fa !important;
}
</style>
